import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Workout } from '@fitscovery/workouts/data-access';
import { Observable } from 'rxjs';
import { Select } from '@ngxs/store';
import { MembershipState } from '@fitscovery/membership/data-access';
import { take } from 'rxjs/operators';

class DisplayData {
  count: number;
  loadMore: boolean;
}

@Component({
  selector: 'fitscovery-ui-workout-list-card',
  templateUrl: './ui-workout-list-card.component.html',
  styleUrls: ['./ui-workout-list-card.component.scss']
})
export class UiWorkoutListCardComponent implements OnInit, OnChanges {
  @Input() workoutData: Workout[];
  @Select(MembershipState.hasActiveStatus) hasActiveStatus$: Observable<boolean>;
  @Select(MembershipState.hasPendingStatus) hasPendingStatus$: Observable<boolean>;
  isStatusPending: boolean;
  isActive: boolean;
  isLoading: boolean;
  workoutValue: string;

  dataDisplayCount: number;
  showLoadMore: boolean;
  openForMembersOnly: boolean;
  hasActiveStatus: boolean;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.isActive = false;
    this.isLoading = true;
    this.openForMembersOnly = false;
    this.setDataDisplayLimit();
    this.hasActiveStatus$.pipe(take(1)).subscribe(async (hasActiveStatus) => {
      this.hasActiveStatus = hasActiveStatus;
    });

    this.hasPendingStatus$.pipe(take(1)).subscribe(async (hasPendingStatus) => {
      this.isStatusPending = hasPendingStatus;
    });
  }

  ngOnChanges(changes: any) {
    this.workoutValue = changes.workoutData.currentValue;

    if (this.workoutValue !== undefined) {
      this.isLoading = false;
      this.setDataDisplayLimit();
    }
  }

  goToWorkoutDetails(workoutId: string, isForMembersOnly: boolean) {

    if (isForMembersOnly === true && this.hasActiveStatus) {
      this.router.navigate([`workouts/members-only/${workoutId}`]);
    } else if (isForMembersOnly === true) {
      this.openForMembersOnly = !this.openForMembersOnly;
    } else {
      this.router.navigate([`workouts/${workoutId}`]);
    }
  }

  bookmarkCard() {
    this.isActive = !this.isActive;
  }

  setDataDisplayLimit() {
    if (this.workoutData) {
      const totalData = this.workoutData.length;
      const initialDisplay = 50;
      const initialDisplayData = this.setInitialDisplayData(totalData, initialDisplay);

      this.dataDisplayCount = initialDisplayData.count;
      this.showLoadMore = initialDisplayData.loadMore;
    }
  }

  displayData() {
    const totalData = this.workoutData.length;
    const increment = 50;
    const count = this.dataDisplayCount;
    const displayData = this._displayData(totalData, increment, count);

    this.dataDisplayCount = displayData.count;
    this.showLoadMore = displayData.loadMore;
  }

  backToList(x?: any) {
    this.openForMembersOnly = !this.openForMembersOnly;
  }

  setInitialDisplayData(data: number, initial: number): DisplayData {
    const dataCount = data > initial ? initial : data;
    const loadMore = data > initial ? true : false;

    return {
        count: dataCount,
        loadMore: loadMore
    };
  }

  _displayData(data: number, increment: number, count: number): DisplayData {
      var displayIncrement: number = 0;

      if (data > count) {
          const remaining = data - count;
          displayIncrement = increment > remaining ? remaining : increment;
      }

      const displayedData = count + displayIncrement; 
      const remainingData = data - displayedData;
      const dataCount = data >= displayedData ? displayedData : count += remainingData;
      const loadMore = (remainingData <= 0) ? false : true;

      return {
          count: dataCount,
          loadMore: loadMore
      };
  }
}
